import React from "react";

class LeftArrow extends React.Component {
  render() {
    return (
      <svg
        height="2.7em"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#fca25c"
          d="M418.913928 509.533832l330.167698-330.179978c27.76639-27.768437 27.76639-72.786747 0.026606-100.540857-27.76639-27.783787-72.812329-27.783787-100.553137 0L274.53054 452.837552c-15.523555 15.511275-22.055318 36.420491-20.246113 56.69628-1.809205 20.274766 4.722558 41.158399 20.246113 56.681954L648.555096 940.240341c27.739784 27.768437 72.786747 27.768437 100.553137 0 27.739784-27.739784 27.739784-72.758094-0.026606-100.523461L418.913928 509.533832z"
        />
      </svg>
    );
  }
}

export default LeftArrow;
